import { API_BASE_URL } from '../../config/config';
import { UserClient } from '../../services/apiClient';
import axiosInstance from '../../services/axiosInstance';

export const fetchProfilePictures = async (list: any[]) => {
  const userClient = new UserClient(API_BASE_URL, axiosInstance);

  const picUrls = await Promise.all(
    list.map(async (listItem) => {
      try {
        const picResponse = await userClient.generateProfilePictureSas(listItem.userId ?? listItem.id);
        return picResponse.success ? (picResponse.data ?? '') : '';
      } catch (err) {
        console.error(
          `Failed to fetch profile picture for user ${listItem.firstName}`,
          err,
        );
        return '';
      }
    }),
  );

  return picUrls;
};
